export default __webpack_public_path__ + "ab6d0591d5e755c553d66b3816195110.svg";